export const documentExists = () => {
    return typeof window !== 'undefined'
}
